export class VistoriaModel {

    filtro_data_inicial: Date
    filtro_data_final: Date

    cod_vistoria_elevador_novo?: string
    situacao?: string
    venda_total?: number
    valor_fechado?: number
    valor_con?: number
    valor_man?: number
    total_ortobras?: number
    valor_total_espel?: number
    data?: Date
    data_fechamento?: Date
    nome?: string
    coligada?: string
    endereco?: string
    vendedor?: string

    descricaoTitulo?: string
    total_dinheiro?: number
    quantidade_vistoria?: number
    media_vistoria?: number

    total_dinheiro_texto?: string
    quantidade_vistoria_texto?: string
    media_vistoria_texto?: string

}
